export default __webpack_public_path__ + "static/media/soup.bc9ca751.svg";